import axios from "axios";
import { getFileHeaders, getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const createMobileUploadApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.CreateMobileUpload,
    method: "post",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => (err.response ? err.response.data : {}));

  return callResponse;
};

export const getMobileUploadStatusApi = async (uploadId) => {
  const callResponse = await axios({
    url: `${endpoints.MobileUploadStatus}/${uploadId}`,
    method: "get",
    headers: getHeaders(),
  })
    .then((response) => response.data?.data)
    .catch((err) => (err.response ? err.response.data : {}));

  return callResponse;
};

export const deleteMobileUploadApi = async (uploadId) => {
  const callResponse = await axios({
    url: `${endpoints.MobileUploadDelete}${uploadId}`,
    method: "delete",
    headers: getHeaders(),
  })
    .then((response) => response.data)
    .catch((err) => (err.response ? err.response.data : {}));

  return callResponse;
};

export const uploadMobileFileApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.MobileUploadUpload,
    method: "post",
    headers: getFileHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => (err.response ? err.response.data : {}));

  return callResponse;
};
